import React, { useContext } from 'react';
import DesktopDevPageDisplaySide300x250 from '@wix/da-ads/pkg/adunits/DesktopDevPageDisplaySide300x250';
import MobileDevPageDisplaySide300x250 from '@wix/da-ads/pkg/adunits/MobileDevPageDisplaySide300x250';
import DesktopDevPageSideVideoSide from '@wix/da-ads/pkg/adunits/DesktopDevPageSideVideoSide';
import ErrorBoundary from '../../../../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Ad.scss';
var Ad = function (_a) {
    var block = _a.block, adSafety = _a.adSafety, deviation = _a.deviation;
    var isMobile = useContext(MobileContext);
    // Mobile only has BTF
    if (isMobile && block.contentType === 'ad_top') {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ErrorBoundary, { debugComponent: "SidebarAd" },
            block.contentType === 'ad_top' && (React.createElement("div", { className: s['video'] },
                React.createElement(DesktopDevPageSideVideoSide, { safety: adSafety }))),
            block.contentType === 'ad_btf' && (React.createElement("div", { className: s['display'] },
                !isMobile && (React.createElement(DesktopDevPageDisplaySide300x250, { safety: adSafety })),
                isMobile && React.createElement(MobileDevPageDisplaySide300x250, { safety: adSafety }))))));
};
Ad.displayName = 'Ad';
export default Ad;
//# sourceMappingURL=Ad.js.map